/**
 * 安全教育考试api
 */
import * as API from '../'

export default {
    /** pageList
     * 题库列表
     */
    getQuestionBankList: params => {
        return API.GET(`/clouddo-tranning/training/library/pageListRewrite`, params)
    },
  /**pageListRewrite
   * 题库列表
   */
  getQuestionBankListRewrite: params => {
    return API.GET(`/clouddo-tranning/training/library/pageListRewrite`, params)
  },
    /**
     * 课程 option 列表
     */
    getProgramOptions:  params => {
      return API.GET(`/clouddo-tranning/training/program/options`, params)
    },
    /**
     * 题库详情查询
     */
    getQuestionBankDetail: params => {
        return API.GET(`/clouddo-tranning/training/library/getDataDetail`, params)
    },
    /**
     * 试题目录
     */
    getCatalogList: params => {
        return API.GET(`/clouddo-tranning/training/directory/getList`, params)
    },
  /**
   * 题库信息
   */
    getQuestionList: params => {
      return API.GET(`/clouddo-tranning/question-bank/admin/page-list`, params)
    },
  getAllList: params => {
    return API.GET(`/clouddo-tranning/question-bank/admin/all-list`, params)
  },
    /**
     * 加载师资option列表
     */
    getTeachersOptions: params => {
      return API.GET(`/clouddo-tranning/tranning/teachers/options`, params)
    },
    /**
     * 题库增加
     */
    addLibrary: params => {
        return API.POST(`/clouddo-tranning/training/library/add`, params)
    },
    /**
     * 题库
     */
    delLibrary: params => {
        return API.POST(`/clouddo-tranning/training/library/deleteQuestion`, params)
    },
    /**
     * 题库修改
     */
    updateLibrary: params => {
        return API.POST(`/clouddo-tranning/training/library/modify`, params)
    },

    /**
     * 试卷列表
     */
    getPaperList: params => {
        return API.GET(`/clouddo-tranning/traning/paper/pageList`, params)
    },
  getPaperListRewrite: params => {
    return API.GET(`/clouddo-tranning/traning/paper/pageListRewrite`, params)
  },
  getPagePaperList: params => {
    return API.GET(`/clouddo-tranning/traning/paper/pagePaperList`, params)
  },
    //添加试卷
    addPaper: params => {
        return API.POST(`/clouddo-tranning/traning/paper/add`, params)
    },
    getPaperDetail: params => {
        return API.POST(`/clouddo-tranning/traning/paper/getDataDetail`, params)
    },
    getPaperNewDetail: params => {
        return API.POST(`/clouddo-tranning/traning/paper/getNewDataDetail`, params)
    },
    copyPaper: params => {
        return API.POST(`/clouddo-tranning/traning/paper/copy`, params)
    },
    updatePaper: params => {
        return API.POST(`/clouddo-tranning/traning/paper/modify`, params)
    },
    importPaper: params => {
      return API.POST(`/clouddo-tranning/traning/paper/import`, params)
    },
    addPaperDetail: params => {
        return API.GET(`/clouddo-tranning/traning/paper/getSaveDetail`, params)
    },
    //删除试卷
    delPaper: params => {
        return API.POST(`/clouddo-tranning/traning/paper/deletePaper`, params)
    },
    /**
     * 题库管理-根据目录查询对应题库
     */
    getLibraryListById: params => {
        return API.GET(`/clouddo-tranning/training/library/getDataList`, params)
    },
    /**
     * 考试管理-列表查询(考试统计)
     */
    examStatisticsList: params => {
        return API.GET(`/clouddo-tranning/training/detail/list/pageList`, params)
    },
    /**
     * 题库导出
     */
    libraryExportQuestion: params => {
        return API.POST(`/clouddo-tranning/training/library/exportQuestion`, params)
    },
    examManageSave: params => {
        return API.POST(`/clouddo-tranning/training/detail/list/save`, params)
    },
    /**
     * 考试统计
     */
    trainingStatisticsList: params => {
        return API.GET(`/clouddo-tranning/training/detail/count/pageList`, params)
    },
    /**
     * 考试统计详情
     */
    trainingStatisticsListDetail: params => {
        return API.GET(`/clouddo-tranning/training/detail/count/getDetil`, params)
    },
    getNewExamDetail: params => {
        return API.GET(`/clouddo-tranning/training/program/getNewExamDetail`, params)
    },
    importData: params => {
        return API.POST(`/clouddo-tranning/training/library/uploadExcel`, params)
    },
    downExcel: params => {
        return API.POST(`/clouddo-tranning/training/library/downExcel`, params)
    },
    directoryList: params => {
        return API.GET(`/clouddo-tranning/training/directory/pageList`, params)
    },
    saveDirectory: params => {
        return API.POST(`/clouddo-tranning/training/directory/save`, params)
    },
    delDirectory: params => {
        return API.POST(`/clouddo-tranning/training/directory/deleteOrAble`, params)
    },
    exportExcel: params => {
        return API.GETBLOB(`/clouddo-tranning/training/library/exportExcel`, params)
    },
    trainingDetailExport: params => {
        return API.GETBLOB(`/clouddo-tranning/training/detail/count/export`, params)
    },
    trainingDetailExportPaper: params => {
        return API.GETBLOB(`/clouddo-tranning/training/detail/count/exportPaper`, params)
    },
    /**
     * 根据id删除试题
     * @param params
     * @returns {Promise<unknown>}
     */
    delQuestionByIds: params => {
      return API.POST("/clouddo-tranning/training/library/delByIds", params)
    },
    /**
     * 清空试题库
     * @param params
     * @returns {Promise<unknown>}
     */
    clearQuestionBank:  params => {
      return API.POST("/clouddo-tranning/training/library/clearQuestionBank", params)
    }
}




// WEBPACK FOOTER //
// ./src/api/new/exam.js